import { h, render, Component } from 'preact';

class TxrNavSubmenuSolutions extends Component {
    state = {
    }
    render() {
        return (
            <div class="txr-nav-submenu">
                <div class="submenu-mobile-back" onClick={() => this.props.onClose()}>
                    <img class="submenu-mobile-back__icon" src="/images/navigation/icon-arrow-nav.svg"></img>
                    <span class="submenu-mobile-back__text">Solutions</span>
                </div>
                <div class="txr-nav-submenu-content solutions">
                    <div class="submenu-left">
                        <div class="submenu-nav">
                            <a class="submenu-nav-item" href="/solutions">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">Solutions Overview</span>
                            </a>
                            <a class="submenu-nav-item submenu-nav-item__only-mobile" href="/industries">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">Industries Overview</span>
                            </a>
                            <div class="submenu-nav__line"></div>
                        </div>
                        <div class="submenu-menus">
                            <div class="submenu-header submenu-header__only-mobile">SOLUTIONS</div>
                            <a class="submenu-item" href="/solutions/collections">
                                <i class="submenu-item__image-icon fal fa-file-invoice-dollar"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Collecting Payments
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/solutions/conversations">
                                <img class="submenu-item__image" alt="sumbenu" src="/images/navigation/icon-conversations.svg" />
                                <img class="submenu-item__image-hover" alt="sumbenu" src="/images/navigation/icon-conversations-green.svg" />
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Conversations
                                    </div>
                                </div>
                            </a>                         
                            <a class="submenu-item" href="/solutions/lead-generation">
                                <i class="submenu-item__image-icon fal fa-filter-circle-dollar"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Lead Generation
                                    </div>
                                </div>
                            </a> 
                            <a class="submenu-item" href="/solutions/scheduling">
                                <i class="submenu-item__image-icon fal fa-calendar-clock"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Scheduling & Sequences
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/solutions/sms-marketing">
                                <i class="submenu-item__image-icon fal fa-sitemap"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    SMS Marketing
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="submenu-right">
                        <div class="submenu-nav submenu-nav__only-desktop">
                            <a class="submenu-nav-item" href="/industries">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">Industries Overview</span>
                            </a>
                            <div class="submenu-nav__line"></div>
                        </div>
                        <div class="submenu-menus">
                            <div class="submenu-header submenu-header__only-mobile">INDUSTRIES</div>
                            <a class="submenu-item" href="/industries/franchises">
                                <i class="submenu-item__image-icon fal fa-store"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Franchises
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/industries/hvac">
                                <i class="submenu-item__image-icon fal fa-air-conditioner"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    HVAC
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/industries/insurance">
                                <i class="submenu-item__image-icon fal fa-shield-heart"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Insurance
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/industries/nonprofits">
                                <i class="submenu-item__image-icon fal fa-hand-holding-heart"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Nonprofits
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/industries/political-campaigns">
                                <i class="submenu-item__image-icon fal fa-landmark-dome"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Political Campaigns
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrNavSubmenuSolutions;